<template>
  <div
    class="detail_main">
    <div class="detail_container" :class="{'bg_detail': bg}">
      <section
        class="size_detail zero_right margin_top_detail padding_bottom_detail has-background-white">
        <transition
          name="custom-classes-transition"
          enter-active-class="animated slideInRight"
          leave-active-class="animated slideOutRight"
          :duration="1000">
          <div class="column container_diapo is-paddingless">
            <img class="diapo_img" v-if="url(detailTem[currentImg].urlPhoto)"
            :src="url(detailTem[currentImg].urlPhoto)" alt="">
            <div class="action_diapo">
              <a v-if="showDiapo"
                class="button has-text-white is-rounded diapo_button"
                :class="{'is-primary': hoverButton}"
                @click="$parent.showDiapo = false"
                @mouseover.prevent="hoverButton = true"
                @mouseout.prevent="hoverButton = false">
                <span class="icon">
                  <b-icon
                    icon="image-multiple"
                    size="is-small">
                  </b-icon>
                </span>
                <p class="p_size14">Quitter diaporama</p>
              </a>
              <a v-else
                class="button has-text-white is-rounded diapo_button"
                :class="{'is-primary': hoverButton}"
                @click="$parent.show = false"
                @mouseover.prevent="hoverButton = true"
                @mouseout.prevent="hoverButton = false">
                <span class="icon">
                  <b-icon
                    icon="image-multiple"
                    size="is-small">
                  </b-icon>
                </span>
                <p class="p_size14">Quitter diaporama</p>
              </a>
              <a
                class="button has-text-white is-rounded diapo_button_n">
                <p class="p_size14">{{currentImg+1}}/{{detailTem.length}}</p>
              </a>
            </div>
            <div class="level diapo_arrow">
              <div class="level-left">
                <a @click.prevent="leftScroll()" v-if="currentImg!=0">
                  <svg style="width: 32px;height: 32px;background-color: white;border-radius: 50%;"
                    viewBox="0 0 24 24">
                    <path fill="#000"
                    d="M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1
                    12,22A10,10 0 0,1 2,12M18,11H10L13.5,7.5L12.08,
                    6.08L6.16,12L12.08,17.92L13.5,16.5L10,13H18V11Z" />
                  </svg>
                </a>
              </div>
              <div class="level-right">
                <a @click.prevent="rightScroll()" v-if="currentImg!=detailTem.length-1">
                  <svg style="width: 32px;height: 32px;background-color: white;border-radius: 50%;"
                    viewBox="0 0 24 24">
                    <path fill="#000"
                    d="M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0
                     0,1 12,2A10,10 0 0,1 22,12M6,13H14L10.5,16.5L11.92,17.92L17.84,
                     12L11.92,6.08L10.5,7.5L14,11H6V13Z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </transition>
        <div class="column is-marginless is-12 detail_content is-marginless content_background">
          <div class="topVert leftVert rightVert">
            <div>
              <p class="has-text-link">
              Nom Réseau:</p>
              <h3 class="has-text-weight-bold has-text-link bottomVert">{{reseau}}</h3>
            </div>
            <div class="columns is-marginless is-12 color-icon">
              <div class="column is-3 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="barcode"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Code face
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailTem[currentImg].facCode}}
                      </p>
                  </div>
                </div>
              </div>
              <div class="column is-3 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Format
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailTem[currentImg].format}}
                      </p>
                  </div>
                </div>
              </div>
              <div
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="map-marker"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Adresse
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{adresse(detailTem[currentImg])}}
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { urlPhoto, formatAdresse } from '@/services/opportunite/formatTab';

export default {
  name: 'diapoTempo',
  props: ['detailTem', 'reseau', 'showDiapo', 'bg'],
  data() {
    return {
      currentImg: 0,
      hoverButton: false,
    };
  },
  methods: {
    url(u) {
      return urlPhoto(u);
    },
    adresse(d) {
      return formatAdresse(d);
    },
    leftScroll() {
      if (this.currentImg === 0) {
        this.currentImg = 1;
      }
      this.currentImg -= 1;
    },
    rightScroll() {
      if (this.currentImg === (this.detailTem.length - 1)) {
        this.currentImg = -1;
      }
      this.currentImg += 1;
    },
    exit() {
      if (this.showDiapo) this.$parent.showDiapo = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxTempo/diapoTempo.vue